module.exports = __webpack_public_path__ + "files/621cd820438f081310a1719ead5cd1cb.png";